export const roleAuthorities = [
    {
        name: '基本申請',
        children: [
            {
                name: '申請、查詢個人請款單',
                info: '新增請款單',
                preferRole: '員工',
                unt: 'A01',
            },
            {
                name: '請款委外管理',
                info: '新增外包廠商/勞務，包含基本資料與存款帳號',
                preferRole: '員工',
                unt: 'C03',
            },
            {
                name: '請款委外類型設定',
                info: '外包廠商分類設定',
                preferRole: '員工',
                unt: 'C06',
            },
            {
                name: '發票申請',
                info: '申請開立銷貨發票、專案核銷收入',
                preferRole: '員工',
                unt: 'B01',
            },
            {
                name: '客戶管理',
                info: '建立發票/專案客戶基本資訊、聯絡窗口',
                preferRole: '員工',
                unt: 'C02',
            },
        ],
    },
    {
        name: '勞報單管理',
        children: [
            {
                name: '申請勞報單',
                info: '建立勞報單',
                preferRole: '專案人員',
                unt: 'H01',
            },
            {
                name: '勞報單總管理',
                info: '可管理全公司的勞報單',
                preferRole: '專案主管',
                unt: 'H02',
            },
        ],
    },
    {
        name: '專案管理',
        children: [
            {
                name: '專案管理',
                info: '新增專案基本資料',
                preferRole: '專案人員',
                unt: 'C01',
            },
            {
                name: '專案總管理',
                info: '可編輯所有專案內容 、指定專案PM',
                preferRole: '專案主管',
                unt: 'C04',
            },
            {
                name: '專案類型設定',
                info: '專案分類設定',
                preferRole: '專案主管',
                unt: 'C05',
            },
        ],
    },
    {
        name: '查詢',
        children: [
            {
                name: '請款單查詢',
                info: '瀏覽、查詢全部請款單',
                preferRole: '權限管理者',
                unt: 'Q01',
            },
            {
                name: '發票查詢',
                info: '瀏覽、查詢全部發票',
                preferRole: '權限管理者',
                unt: 'Q02',
            },
            {
                name: '專案查詢',
                info: '瀏覽、查詢全部專案',
                preferRole: '權限管理者',
                unt: 'Q03',
            },
            {
                name: '財務收支查詢',
                info: '瀏覽、查詢全部財務收支',
                preferRole: '權限管理者',
                unt: 'Q04',
            },
        ],
    },
    {
        name: '收付款作業',
        children: [
            {
                name: '填寫付款明細',
                info: '依據請款內容，填寫付款方式與支出項目',
                preferRole: '行政出納',
                unt: 'A02',
            },
            {
                name: '發票開立',
                info: '填寫開立發票內容、編輯收入項目',
                preferRole: '行政出納',
                unt: 'B02',
            },
            {
                name: '確認付款、財務支出',
                info: '再次核對付款明細及支出項目，請款單即標示完成',
                preferRole: '財務管理',
                unt: 'A03',
            },
            {
                name: '發票入帳',
                info: '確認發票入帳、作廢、銷貨折讓退款，編輯收入項目',
                preferRole: '財務管理',
                unt: 'B03',
            },
        ],
    },
    {
        name: '審核相關設定',
        children: [
            {
                name: '特定費用項目設定',
                info: '建立特定專案指定特定審核流程（例如：設備資產支出、採購分期付款、裝潢工程）',
                preferRole: '高階財務管理',
                unt: 'F01',
            },
            {
                name: '經常性費用設定',
                info: '固定小額費用支出（例如：清潔費、享食福利）',
                preferRole: '高階財務管理',
                unt: 'F02',
            },
            {
                name: '審核流程設定',
                info: '設定請款單金額級距、指定審核人（例如主管，或特定金額以上）',
                preferRole: '高階財務管理',
                unt: 'F22',
            },
        ],
    },
    {
        name: '對帳、小幫手',
        children: [
            {
                name: '幣別與匯率設定',
                info: '提供每日即期匯率參考',
                preferRole: '行政出納、財務管理',
                unt: 'F04',
            },
            {
                name: '收支日曆',
                info: '每日請款、發票、財務收支金額統計、檢視單據',
                preferRole: '行政出納、財務管理',
                unt: 'F13',
            },
        ],
    },
    {
        name: '財務設定與管理',
        children: [
            {
                name: '零用現金管理',
                info: '設定銀行提領現金轉入、與零用現金結存轉出',
                preferRole: '高階財務管理',
                unt: 'E02',
            },
            {
                name: '財務收支管理',
                info: '建立非經請款單與發票的財務收入/支出、銀行帳戶互轉（由財務管理人員依據銀行存款收支紀錄）',
                preferRole: '高階財務管理',
                unt: 'E01',
            },
            {
                name: '人事薪資',
                info: '依據薪資總表、建立薪資支出、績效獎金、代扣事項等',
                preferRole: '高階財務管理',
                unt: 'E03',
            },
            {
                name: '銀行帳戶設定',
                info: '設定公司銀行往來帳戶',
                preferRole: '高階財務管理',
                unt: 'F03',
            },
            {
                name: '收支項目設定',
                info: '公司主要的營業收入/支出項目，包含財務收支損益項目（符合營運收支項目，作為分析的依據）',
                preferRole: '高階財務管理',
                unt: 'F05',
            },
            {
                name: '營收目標設定',
                info: '編輯每月營收目標',
                preferRole: '高階財務管理',
                unt: 'F14',
            },
            {
                name: '公司資訊設定',
                info: '編輯公司基本資料、固定付款日、Invoice 帳戶資訊',
                preferRole: '高階財務管理',
                unt: 'F23',
            },
            {
                name: '銀行匯款明細、匯費',
                info: '核對銀行扣款支出對象與金額、填寫匯費',
                preferRole: '行政出納、財務管理',
                unt: 'E04',
            },
            {
                name: '發票字軌管理',
                info: '設定已購買發票期別、編輯銷售發票字軌號碼',
                preferRole: '行政出納',
                unt: 'F24',
            },
            {
                name: '借款管理',
                info: '管理公司每一筆借款的日期、貸款利率、借款方式期間、借款餘額、還款進度、利息支出',
                preferRole: '老闆、高階財務管理',
                unt: 'D22',
            },
            {
                name: '核銷轉開發票',
                info: '暫收客戶款項,或小額收款 以核銷單列收入開立發票或分次開立不同期別的銷售發票,併入營業稅申報',
                preferRole: '高階財務管理',
                unt: 'D23',
            },
        ],
    },
    {
        name: '分析',
        children: [
            {
                name: '營業收支總覽',
                info: '可觀看年度營業收入/支出/淨收、圖表、統計數據',
                preferRole: '老闆、主管、行政出納、財務管理',
                unt: 'D11',
            },
            {
                name: '存款總覽',
                info: '可觀看公司各銀行帳戶、現金餘額、每月曲線走向',
                preferRole: '老闆、主管、行政出納、財務管理',
                unt: 'D12',
            },
            {
                name: '現金流量分析',
                info: '可觀看每月金流統計數據',
                preferRole: '老闆、主管、行政出納、財務管理',
                unt: 'D13',
            },
            {
                name: '營業收入分析',
                info: '依收入項目，呈現收入分類統計、比例',
                preferRole: '老闆、主管',
                unt: 'D14',
            },
            {
                name: '營業支出分析',
                info: '依支出項目，呈現支出分類統計、比例',
                preferRole: '老闆、主管',
                unt: 'D15',
            },
            {
                name: '同期比較',
                info: '自訂區間，觀看營業總收入、支出、淨收比較',
                preferRole: '老闆、主管',
                unt: 'D16',
            },
            {
                name: '客戶貢獻',
                info: '依開立銷售發票排行客戶',
                preferRole: '老闆、主管',
                unt: 'D17',
            },
            {
                name: '自結損益表',
                info: '讓您知道公司經營在特定一段時間內到底賺不賺錢',
                preferRole: '老闆、主管',
                unt: 'D18',
            },
            {
                name: '財務分析表',
                info: '觀察公司現金存款資產的流動情形',
                preferRole: '老闆、主管',
                unt: 'D19',
            },
            {
                name: '年度預估營業淨收',
                info: '以實際營收趨勢比對做出未來年度計畫、營業額、 成本、支出、未來預估營收淨利',
                preferRole: '老闆、主管',
                unt: 'D20',
            },
        ],
    },
    {
        name: '申報',
        children: [
            {
                name: '營業稅申報',
                info: '快速申報、匯出媒體檔',
                preferRole: '會計',
                unt: 'G03',
            },
            {
                name: '外部進項發票',
                info: '提供公司因某部分費用非由公司實際支出',
                preferRole: '',
                unt: 'D21',
            },
            {
                name: '勞務稅、健保申報',
                info: '勞務稅款、二代健保申報統計表',
                preferRole: '會計',
                unt: 'G04',
            },
            {
                name: '年度扣繳申報',
                info: '年度勞務稅款、二代健保申報總表',
                preferRole: '會計',
                unt: 'G05',
            },
            {
                name: '申報文件管理',
                info: '管理年度各類申報文件',
                preferRole: '會計',
                unt: 'G13',
            },
        ],
    },
    {
        name: '會計專區',
        children: [
            {
                name: '帳務匯總表',
                info: '依照帳務類型分類匯總作為編輯傳票作業依據',
                preferRole: '財務、會計',
                unt: 'G01',
            },
            {
                name: '會計報表',
                info: '會計資產負債表、綜合損益表、會計科目餘額試算表',
                preferRole: '會計',
                unt: 'G07',
            },
            {
                name: '專案會計報表',
                info: '產出專案產出會計資產負債表、綜合損益表',
                preferRole: '會計',
                unt: 'G16',
            },
            {
                name: '財會檢核',
                info: '檢核完成後，會計傳票不得修改',
                preferRole: '財務',
                unt: 'G10',
            },
            // {
            //     name: '年度會計總管理（僅限一人）',
            //     info: '年度會計報表鎖定、關帳、未列入傳票處理',
            //     preferRole: '會計',
            //     unt: 'G15',
            // },
        ],
    },
];

export default roleAuthorities;
